import { createApp } from 'vue';
import CommonPlugin from 'plugins/common-plugin';
import { i18n } from 'utils/i18n';
import store from 'stores/generic';
import LoginPage from 'views/LoginPage.vue';

require('styles/pages/page.less');

const app = createApp({
  components: { LoginPage }
});

app.use(CommonPlugin);
app.use(store);
app.use(i18n);

app.mount('#app');
